module.exports = __webpack_public_path__ + "media/charts/GEOGRAPHICSPREAD-0633bfb1.svg";